module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "sec12"
    }
  }), _vm._v("C Is for Cher")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Culture miniature and clad as Cleopatra, she descends"), _c('br'), _vm._v("A set of semicircular steps"), _c('br'), _vm._v("Tiled in a geometric mosaic pattern")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And there she finds the answer: everything"), _c('br'), _vm._v("Changes depending on whether"), _c('br'), _vm._v("You’re up or down. Behind her,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("A high-relief rectangle proscenium;"), _c('br'), _vm._v("Beside her, whatever intrigued her last."), _c('br'), _vm._v("An unofficial fan leaps feverishly into action. At that,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("She seems to multiply. History will be filled"), _c('br'), _vm._v("With the shower of dots that will become her."), _c('br'), _vm._v("At that, she becomes. It’s complex.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Through the glass she sees a pair of dazzling slippers."), _c('br'), _vm._v("At dinner her drink was called a Vladimir,"), _c('br'), _vm._v("Hers was the plate that contained Washington oysters.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("There she held a fork. There she was on a stage"), _c('br'), _vm._v("Of discourse. Of course. Mickey Mouse comes over"), _c('br'), _vm._v("And stops to stare. Cher is dressed in a long gold dress.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The sequins form stripes. “If I could turn back time.”"), _c('br'), _vm._v("She’s singing. And Mickey in his red pants is acting"), _c('br'), _vm._v("Like the goodwill minister to an enraptured world.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("Mickey thinks. He turns the corner."), _c('br'), _vm._v("To the gift shop: ever open."), _c('br'), _vm._v("He buys retractable mother-of-pearl opera glasses")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("As a present. Yes, it’s over. The present."), _c('br'), _vm._v("In which you discovered forward-thinking thought.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ac2ce6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1_g.vue
// module id = 105
// module chunks = 0